module.exports = __webpack_public_path__ + "static/media/Yala Leopard Diary Logo.b23aed25.png";